import CommercialBanner from './Commercial/CommercialBanner';
import CommercialCosts from './Commercial/CommercialCosts';
import CommercialBenefits from './Commercial/CommercialBenefits';
import CommercialBrands from './Commercial/CommercialBrands';
import CommercialIndustries from './Commercial/CommercialIndustries';
import CommercialFAQ from './Commercial/CommercialFAQ';
import CommercialCTA from './Commercial/CommercialCTA';

export default function Commercial() {
  return (
    <div className="commercial-page">
      <CommercialBanner />
      <CommercialCosts />
      <CommercialBenefits />
      <CommercialIndustries />
      <CommercialBrands />
      <CommercialFAQ />
      <CommercialCTA />
    </div>
  );
}
